import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconExperience = ({ id, color, width = 18, style, ...restProps }: IProps) => {
  const viewBoxWidth = 18;
  const viewBoxHeight = 15;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M18 6.7c0-.1-.1-.2-.2-.2l-2.4-.3-1.1-2c-.1-.1-.2-.2-.3-.2-.1 0-.2.1-.3.2l-1.1 2-2.4.3c-.1 0-.2.1-.2.2s0 .2.1.3l1.7 1.5-.4 2.2c0 .1 0 .2.1.3.1.1.2.1.3 0l2.1-1 2.1 1h.1c.1 0 .1 0 .2-.1s.1-.2.1-.3L16 8.4l1.7-1.5c.3 0 .3-.1.3-.2zM4.5 7.6c2.2 0 3.9-1.7 3.9-3.8C8.4 1.7 6.7 0 4.5 0S.6 1.7.6 3.8c0 2.1 1.7 3.8 3.9 3.8zm0-6.4c1.5 0 2.7 1.2 2.7 2.6 0 1.4-1.2 2.6-2.7 2.6-1.5 0-2.7-1.2-2.7-2.6 0-1.5 1.2-2.6 2.7-2.6zM4.5 8.5C2 8.5 0 10.5 0 12.9v1.5c0 .3.3.6.6.6s.6-.3.6-.6v-1.5c0-1.8 1.5-3.2 3.3-3.2s3.3 1.4 3.3 3.2v1.5c0 .3.3.6.6.6s.6-.3.6-.6v-1.5c0-2.4-2-4.4-4.5-4.4z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconExperience;
